import { Card } from '@/components/atoms/Card';
import { type GuideLink } from '@/contents/marketGuide';
import { cn } from '@/utils/tailwind';
// import LinkButton from '@/components/molecules/LinkButton';
import AlarmInfoIcon from '@/assets/icons/AlarmInfoIcon.svg?react';
import YouTube from 'react-youtube';
import { Button, ButtonProps } from '@/components/atoms/NewPcButton';
import { Link } from 'react-router-dom';
import ExternalIcon from '@/assets/icons/OrderDetails/external-link-fill.svg?react';

type LinkGuideProps = {
  guide: GuideLink;
  className?: string;
};

const LinkGuide = ({ guide, className }: LinkGuideProps) => {
  const { linkUrl, title, mainText, linkButtonText, videoId } = guide.contents;
  const isViewLinkButton = linkButtonText !== undefined && linkButtonText !== '';
  const isViewMainText = Boolean(mainText);

  return (
    <Card key={linkUrl} className={cn(className, 'flex space-x-[10px] p-[30px]')}>
      <AlarmInfoIcon />
      <div>
        <p className=" whitespace-pre-line text-gr-900 Body2M16">{title}</p>
        {isViewMainText && <div className=" mt-[8px] text-gr-800 Body5M14">{mainText}</div>}
        {isViewLinkButton && (
          <div className="mt-[8px]">
            <LinkButton to={linkUrl as string}>{linkButtonText}</LinkButton>
          </div>
        )}
        {videoId && (
          <div className="mt-[16px] h-[188px] w-[335px] overflow-hidden rounded-[12px] bg-black">
            <YouTube
              videoId={videoId}
              opts={{
                width: '335',
                height: '188',
              }}
            />
          </div>
        )}
      </div>
    </Card>
  );
};

export default LinkGuide;

export type LinkButtonProps = {
  children: React.ReactNode;
  to: string;
  target?: React.HTMLAttributeAnchorTarget;
} & ButtonProps;

const LinkButton = ({ children, target = '_blank', to, ...props }: LinkButtonProps) => {
  return (
    <Button
      // className="flex h-[42px] items-center bg-primary-100 text-primary hover:bg-primary-200 active:bg-primary-100"
      variant={'secondary'}
      size="xsmall"
      {...props}
    >
      <Link to={to} target={target} className="flex items-center space-x-[8px]">
        <div className="c-b6">{children}</div>
        <span>
          <ExternalIcon />
        </span>
      </Link>
    </Button>
  );
};
